var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "thumbnail" }, [
    _c("img", {
      staticClass: "finish",
      class: { active: _vm.isSelected },
      attrs: {
        src: _vm.finish.thumbnail,
        alt: _vm.finish.title,
        title: _vm.finish.title,
        "data-title": _vm.finish.title,
        "data-price-no-vat": _vm.finish.price,
        "data-price-plus-vat": _vm.finish.pricePlusVat,
        "data-finish": _vm.finish.renderReference,
        "data-render": _vm.finish.renderReference,
        "data-colour": ""
      },
      on: { click: _vm.select }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }